/**
 * Мапперы ответов расхода: UsageTotalsOut и RateCardOut гейтвея → домен.
 * Имена полей бэка длинные (modelInputTokens) — в домене короче.
 */

import type {RateCard, UsageTotals} from './types';

type Raw = Record<string, unknown>;
export const asObj = (v: unknown): Raw => (typeof v === 'object' && v !== null ? (v as Raw) : {});
export const asNum = (v: unknown): number => (typeof v === 'number' && Number.isFinite(v) ? v : 0);
export const asStr = (v: unknown): string => (typeof v === 'string' ? v : '');

export const toTotals = (raw: unknown): UsageTotals => {
  const r = asObj(raw);
  return {
    modelCalls: asNum(r.modelCalls),
    inputTokens: asNum(r.modelInputTokens),
    outputTokens: asNum(r.modelOutputTokens),
    cachedTokens: asNum(r.modelCachedTokens),
    assistantReplies: asNum(r.assistantReplies),
    dialogs: asNum(r.dialogs),
    waSent: asNum(r.waSent),
    waUtility: asNum(r.waUtility),
    waMarketing: asNum(r.waMarketing),
    waAuthentication: asNum(r.waAuthentication),
    waBillableOther: asNum(r.waBillableOther),
    waServiceFree: asNum(r.waServiceFree),
    // Голосовой помощник: до деплоя бэка полей нет — нули
    voiceCalls: asNum(r.voiceCalls),
    voiceInputTokens: asNum(r.voiceInputTokens),
    voiceOutputTokens: asNum(r.voiceOutputTokens),
  };
};

export const toRateCard = (raw: unknown): RateCard => {
  const r = asObj(raw);
  return {
    aiInputPerMtok: asNum(r.aiInputPerMtok),
    aiOutputPerMtok: asNum(r.aiOutputPerMtok),
    waUtility: asNum(r.waUtility),
    waMarketing: asNum(r.waMarketing),
    waAuthentication: asNum(r.waAuthentication),
  };
};

/** Платных сообщений всего — по всем категориям */
export const paidMessages = (t: UsageTotals): number =>
  t.waUtility + t.waMarketing + t.waAuthentication + t.waBillableOther;
